import { Component, OnInit,ViewChild } from '@angular/core';
import {InquiresService} from '../../_services/inquires/inquires.service'
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-inquiries',
  templateUrl: './inquiries.component.html',
  styleUrls: ['./inquiries.component.css']
})
export class InquiriesComponent implements OnInit {
  Inquires:any=[]
  headerData: Array<any> = [];
  showEdit: Array<boolean> = [];
  // showEdit: { [key: string]: boolean } = {};
  subscriptions:Subscription[] = [];
  monthButton  : boolean= true;
  weekButton  : boolean= false;

  numberInquires=0;
  constructor(private _inquiresService:InquiresService ,private messageService: MessageService,public router: Router) { }
///////////////////////////////////////////
  globalFilter: string = '';

  currentPage: number = 0;
 @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('inqPage', this.currentPage.toString());
  }


  ngOnInit() {
    const savedPage = localStorage.getItem('inqPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)

    ///////////////////////////////////////////////
    this.initFakeData();
    this. getAllInquires(this.statusinquire);
    //////////////////////////////////////////////////
    if(localStorage.getItem('pageNoInq')){
    
      let numberF=Number(localStorage.getItem('firstInq'))

      let numberR=Number(localStorage.getItem('rowsInq'))
      let number=Number(localStorage.getItem('pageNoInq'))

     
      this.first=numberF
      this.rows=numberR
      this.pageNumber=number

      this. getAllInquires(this.statusinquire);

      
    }else{
      // this. getAllInquires(this.statusinquire);

    }
    //////////////////////////////////////////////////
    this.checkRole();
    const connection = new signalR.HubConnectionBuilder()

    .withUrl(environment.apiUrl + '/notify',{ withCredentials: false})
    .build();

  connection.start().then(function () {
  }).catch(function (err) {
    return console.error(err.toString());
  });

  connection.on("NewInquiry", (result: any) => {
    this.getAllInquires(this.statusinquire);
    //this.messageService.add({ severity: 'info', summary: 'New Booking Request', detail: result.noti_Name });

  });
  }
  /////////////////////////////////////////////////////
  statuses = [
    { label: 'Upcoming', value: 'Upcoming' },
    { label: 'Current', value: 'Current' },
    { label: 'Checked Out', value: 'Checked Out' }

  ];
  
  getSeverity(status: string): string {
    switch (status) {
      case 'Upcoming': return 'rounded-5 px-3 badge Upcoming';
      case 'Current': return 'rounded-5 px-3 badge Current';
      case 'Checked Out': return 'rounded-5 px-3 badge Cancelled';

      case 'Completed': return 'rounded-5 px-3 badge Completed';
      case 'Approved': return 'rounded-5 px-3 badge Approved';
      case 'Cancelled': return 'rounded-5 px-3 badge Cancelled';
      case 'Pending': return 'rounded-5 px-3 badge Pending';
      case 'Rejected': return 'rounded-5 px-3  badge Rejected';
      case 'CheckedOut': return 'rounded-5 px-3  badge Waiting';
      case 'Waiting': return 'rounded-5 px-3  badge Waiting';

      default: return '';
    }
  }

  statuses2 = [
    // { label: 'Completed', value: 'Completed' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Cancelled', value: 'Cancelled' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'CheckedOut', value: 'CheckedOut' } ,
    // { label: 'Waiting', value: 'Waiting' } 


  ];
  
  /////////////////////////////////////////////////////
  inquiresRole:any
is_Super:any
checkRole(){
  const data = localStorage.getItem("user");
  console.log(data)
   if (data !== null) {

    let parsedData = JSON.parse(data);
     this.is_Super=parsedData.is_Super
    if(parsedData.is_Super==false) {
for(let i=0; i<parsedData.permissions.length;i++){
  if(parsedData.permissions[i].page_Name=="Inquiries"){
    this.inquiresRole=parsedData.permissions[i];
  }
}
if(this.inquiresRole.p_View==false &&this.is_Super==false) {
  this.gotopage( )
}
}


  }
}
gotopage( ){
  let url: string = "unlegal";
    this.router.navigateByUrl(url);
}
  statusinquire:string="All"
  pageNumber=1;
  pagesize=10;
  totalofPages=0;;
  disablenext=false;
  disableperv=false;
  first: number = 1;
  rows: number = 10;
  incrementpage(){

    this.pageNumber+=1;
    if(this.pageNumber<1){
      this.pageNumber=1;

    }
    if(this.pageNumber>= this.totalofPages){
      this.pageNumber=this.totalofPages;

    }
    this.getAllInquires(this.statusinquire);
  }
  decreamentPage(){
    this.pageNumber-=1;
    if(this.pageNumber<1){
      this.pageNumber=1;

    }
    this.getAllInquires(this.statusinquire);

  }
  date=""
  totalRecords=0;
  no: number = 0; // Initialize the starting index

  displayedInquiries = [];
  getAllInquires(statusinquires:any) {
    // this.Inquires=[]
    this.numberInquires=0
    this.subscriptions.push(this._inquiresService.getAllInquires(  1, 20000,statusinquires,this.date,this.searchText).subscribe((res:any) => {
      // this.Inquires = res["data"];*****
      this.displayedInquiries = res["data"];


      

      // console.log(this.Inquires)
      const sortedData = this.displayedInquiries.sort((a:any, b:any) => {
        // Extract the numeric part from booking_Code, remove 'R#' and parse as number
        const numA = parseInt(a.booking_Code.replace('R#', ''), 10);
        const numB = parseInt(b.booking_Code.replace('R#', ''), 10);

        // Sort in descending order
        return numB - numA;
      });

      this.Inquires=sortedData
      console.log(this.Inquires.length, this.currentPage)

      console.log(sortedData);

      
      // if(this.searchText!==""){
      //   this.Inquires=sortedData
      // }else{
      //   this.displayedInquiries=sortedData;
      //   this.displayNextInquiries()
      // }


      this.numberInquires = this.Inquires.length;
      this.totalofPages=res["totalPages"]
      this.totalRecords=res["totalRecords"]

      if(this.totalofPages==this.pageNumber){
        this.disablenext=true
      }else{
        this.disablenext=false

      }
      if(this.pageNumber==1){
        this.disableperv=true
      }else{
        this.disableperv=false

      }

        /////////////////////////////////////////
        const savedPage = localStorage.getItem('inqPage');
        this.currentPage = savedPage ? +savedPage : 0;
        console.log(this.currentPage) 
        this.tableReady = true;
        /////////////////////////////////////
     }, (error) => {
       console.error('Error fetching owners:', error);
    }))

  }

    // Function to splice the next 8 records
    look:boolean;
    displayNextInquiries() {

      console.log(this.first,this.rows)
      // if( this.look){
      //   this.pageNumber=this.no-1;
      // }else{
      //   this.pageNumber=this.no+1;
      // }

      // this.pageNumber=this.no+1;
      this.no=this.pageNumber-1;
      // Splice the next 8 records from the allInquiries array
      const start = this.no * this.pagesize;
      const end = start + this.pagesize;

      // Check if there are enough records left to splice
      if (start < this.displayedInquiries.length) {
        this.Inquires = this.displayedInquiries.slice(start, end);
        this.no++; // Increment the number for the next batch
        console.log('Displaying inquiries:', this.Inquires);
      } else {
        console.log('No more inquiries to display.');
      }
    }
  tiggerPageChange(event: any) {

    this.first = event.first;
    this.rows = event.rows;
    let calcPageNumber = Math.floor(this.first / this.rows) + 1;
    this.pageNumber = calcPageNumber;
    console.log(this.pageNumber)
        this.getAllInquires(this.statusinquire);
        
        localStorage.setItem('firstInq',this.first.toString())
        localStorage.setItem('pageNoInq',this.pageNumber.toString())


        localStorage.setItem('rowsInq',this.rows.toString())
      }
      ids:any=[]
  detailperson(event:any, id: any){
    this.showEdit=[]
event.stopPropagation()

    this.showEdit[id] == true ? this.showEdit[id] = false : this.showEdit[id] = true
   }
// detailperson(event: any, id: any) {
//   event.stopPropagation();  
//     console.log(id,event)
  
//   this.showEdit[id] = !this.showEdit[id];
// }


  showSide: string = '';

  addItem(value: string): void {
    this.showSide = value
  }
  dropdownOption: Array<any> = [];
  listDropDown:Array<object>=[{name:'All'},{name:'Today'},{name:'Last week'},{name:'This month'},{name:'This year'}]
  Inquiries=[]
  InquireFillterLists: Array<any> = [];
  InquireFillterSelected: Array<any> = [];
  initFakeData(): void {
    this.InquireFillterLists = [
      {id:0,
       name: "All"
      },
      {id:1,
        name:"Waiting for Approve"
      },
      {id:2,
        name: "Waiting List"
      },
      {id:3,
      name:"Confirmed Inquiries"
      },
      {id:4,
      name:"Cancelled Booking"
      },
      {
        id:5,
        name:"Rejected Booking"
      },
      {
        id:6,
        name:"Upcoming Bookings"
      },
      {
        id:7,
        name:"Current Bookings"
      }
    ];
    this.InquireFillterSelected = [true];
   }
   selectedfromDropDown(value:any){
    this.date=value.name;
    this.getAllInquires(this.statusinquire)
 }
 FilterButtons(value:any){
  this.date=value;
  if(this.date == 'This Month'){
    this.monthButton = true;
    this.weekButton = false
  }else{
    this.monthButton = false;
    this.weekButton = true;
  }
  this.getAllInquires(this.statusinquire)
}
  checkindex=0;
  clickIquires(index:any){
    this.checkindex=index?.target?.value;
    this.InquireFillterSelected = this.InquireFillterSelected.map((data) => data == true ? false : false)

    this.InquireFillterSelected[index?.target?.value] = true
    if(index?.target?.value == 0){
      this.statusinquire="All"
      this.getAllInquires(this.statusinquire);
    }
    if(index?.target?.value == 1){
      this.statusinquire="Pending"

      this.getAllInquires(this.statusinquire);
    }
    if(index?.target?.value == 2){
      this.statusinquire="Waiting"

      this.getAllInquires(this.statusinquire);

    }
    if(index?.target?.value == 3){
      this.statusinquire="Approved"

      this.getAllInquires(this.statusinquire);

    }
    if(index?.target?.value == 4){
      this.statusinquire="Cancelled"

      this.getAllInquires(this.statusinquire);

    }
    if(index?.target?.value == 5){
      this.statusinquire=" Rejected"

      this.getAllInquires(this.statusinquire);

    }
    if(index?.target?.value == 6){
      this.statusinquire=" Upcoming"

      this.getAllInquires(this.statusinquire);

    }
    if(index?.target?.value == 7){
      this.statusinquire=" Current"

      this.getAllInquires(this.statusinquire);

    }
  }
  AddWaitingList(id:any){
    this.subscriptions.push( this._inquiresService.AddWaitingList(id).subscribe((res) => {
      this.messageService.add({   severity: 'success', summary: 'Success', detail: res.message});

      this.clickIquires( this.checkindex) ;

     }, (error) => {
      this.messageService.add({   severity: 'error', summary: 'error', detail: error.error.message[0] });
    }))

  }
  display1="none";
  onCloseModal1(){
    this.display1="none"
  }
  idRequest:any
  onOpenModal1(id:any){
    this.Reason="";
    this.idRequest=id;
    this.display1="block"
  }
  Reason=""
  CancelRequest( ){
    this.subscriptions.push( this._inquiresService.CancelRequest(this.idRequest,this.Reason).subscribe((res) => {
      this.clickIquires( this.checkindex) ;
      this.display1="none"
      this.messageService.add({   severity: 'success', summary: 'Success', detail: res.message });


     }, (error) => {
      this.messageService.add({   severity: 'error', summary: 'error', detail: error.error.message[0] });
    }))

  }
  hidecard(id:any){
    //  this.showEdit=[]

  }
  searchText:any=""
  search:boolean=false

  searchKey(data: string) {
    this.searchText = data;
    this.getAllInquires(this.statusinquire)
  }
  searchTextChange:any
  searchAction(event: KeyboardEvent) {
  //   if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
  //     event.preventDefault();
  //     return;
  // }
   console.log('search', this.searchText)
    this.getAllInquires(this.statusinquire)

  }
  ngOnDestroy() {
    for(let i=0;i<this.subscriptions.length;i++)
    this.subscriptions[i].unsubscribe();
  }






  
customSort(event: { data: any[], field: string, order: number }) {
  event.data.sort((a, b) => {
    let valueA = a[event.field];
    let valueB = b[event.field];

    console.log("Before Sorting:", valueA, valueB); // Debugging output

    // ✅ Handle null values properly
    if (valueA == null && valueB == null) return 0;
    if (valueA == null) return event.order;  // Null values should appear last in ascending order
    if (valueB == null) return -event.order; // Null values should appear first in descending order

    // ✅ Convert string dates (like "Mar 5, 2025") into Date objects for sorting
    if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
      let dateA = new Date(valueA);
      let dateB = new Date(valueB);
      let result = (dateA.getTime() - dateB.getTime()) * event.order;

      console.log("Sorted Dates:", dateA, dateB, "Result:", result); // Debugging output

      return result;
    }


      // ✅ التحقق مما إذا كانت القيم تواريخ
      if (this.isDate(valueA) && this.isDate(valueB)) {
        return (new Date(valueA).getTime() - new Date(valueB).getTime()) * event.order;
      }


    // ✅ Handle numeric sorting
    if (!isNaN(valueA) && !isNaN(valueB)) {
      return (parseFloat(valueA) - parseFloat(valueB)) * event.order;
    }

    // ✅ Handle text sorting (case insensitive)
    return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true }) * event.order;
  });

  console.log("After Sorting:", event.data.map(item => item[event.field])); // Debugging output after sorting
}




// ✅ دالة تتحقق مما إذا كانت القيمة تاريخًا
isDate(value: any): boolean {
  return !isNaN(Date.parse(value));
}
 

isValidDate(dateString: string): boolean {
  return dateString != null && !isNaN(Date.parse(dateString));
}


 
}
